// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Select_mainContainer__1WFr5","menuItem":"Select_menuItem__2jHJf"};